<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                自主作业巡课报告
            </div>
            <div class="right"></div>
        </div>
        <div class="main">
            <div class="address">
                <img src="./imgs/address.svg" alt="">
                <span>{{'一年级二班'}}</span>
                <span>{{'2021-11-15 15:40'}}</span>
            </div>
            <ul class="main-ul">
                <li class="main-li" v-for="(item,i) in list" :key="i+item.title">
                    <div class="main-li-box">
                        <p>{{item.title}}</p>
                        <div v-for="(item_1,i_1) in 5" :key="'key'+i_1" :class="{'star-blue':i_1<item.star}" class="star"></div>
                    </div>
                </li>
            </ul>
            <div class="main-li-1">
                <p>综合得分:80</p>
                <span>良好</span>
            </div>
            <div class="main-li-1">
                <p>课堂照片</p>
                <div class="bg">
                    <img v-if="edit" class="del" src="./imgs/del.svg" alt="">
                </div>
                <div class="bg">
                    <img v-if="edit" class="del" src="./imgs/del.svg" alt="">
                </div>
            </div>
            <div class="main-li-1" v-if="edit">
                <p></p>
                <span class="img-upload">
                    添加照片
                </span>
            </div>
            
            <div class="main-li-1">
                <p>巡课人寄语</p>
                <span v-if="!edit">{{textarea}}</span>
                <el-input v-if="edit" type="textarea" resize="none" :rows="4" placeholder="请输入内容" v-model="textarea">
                </el-input>
            </div>
		</div>
        <footer v-if="!edit">
			<el-button style="width:120px;" type="primary" size="" @click='save()'>推送报告</el-button>
			<el-button style="margin-left:20px; width:120px;" size="" @click='edit=true'>编辑报告</el-button>
		</footer>
        <footer v-if="edit">
			<el-button style="width:120px;" type="primary" size="" @click='save()'>编辑完成</el-button>
			<el-button style="margin-left:20px; width:120px;" size="" @click='edit=false'>取消编辑</el-button>
		</footer>
    </div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
	props:['info'],
	components:{
        
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				name: '',
				title: '',
			},
			tableData: [],
			list:[
				{title:'班级卫生',star:3},
				{title:'学习氛围',star:3},
				{title:'课件配套情况',star:3},
				{title:'教师授课态度',star:3},
                {title:'学生听课情况',star:3},
			],
            edit:false,
            textarea:'本周李老师的课堂氛围很好，学生互动积极，但有部分学生有上课睡觉的行为，希望后面李老师可以加强对课上纪律的监管',
		}
	},
	computed:{

	},
	watch: {

	},
	created() {
		
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				page:this.pageNum,
				limit:this.pageSize,
				classId:this.info.classId,
				courseName:this.queryParams.title,
				studentName:this.queryParams.name,
			}
			// let res= await api.studentCourseStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
			// console.log('学生分布详情',res)
		},
        toIndex(){
            this.$emit('to-index')
        },
		save(){},
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}
	.main{
		width: 100%;
		height: 100%;
        .address{
            display: flex;
            align-items: center;
            justify-content: center;
            span{
                margin-left: 20px;
            }
        }
		.main-title{
			display: flex;
			align-items: center;
			p{
				font-weight: bold;
				font-size: 14px;
				color: #181c26;
				margin-left: 10px;
			}
		}
        .main-ul{
            width: 100%;
            .main-li{
                width: 50%;
                display: inline-block;
                font-size: 14px;
                color: #888;
                margin-top: 20px;
                .main-li-box{
                    display: flex;
                    align-items: center;
                    p{
                        width: 120px;
                        text-align: right;
                        margin-right: 20px;
                    }
                    .star{
                        width: 22px;
                        height: 10px;
                        margin-left: 10px;
                        border-radius: 2px;
                        background: #4991e1;
                        opacity: 0.1;
                    }
                    .star-blue{
                        opacity: 1;
                    }
                }
            }
        }
		.main-li-1{
            margin-top: 20px;
            width: 100%;
            display: flex;
            font-size: 14px;
            color: #888;
            p{
                width: 120px;
                text-align: right;
                margin-right: 20px;
            }
            span{
                width: calc(100% - 150px);
            }
            .bg{
                width: 215px;
                height: 160px;
                border-radius: 2px;
                background: #efefef;
                margin-right: 20px;
                position: relative;
                .del{
                    position: absolute;
                    right: -15px;
                    top: -12px;
                    cursor: pointer;
                }
            }
            .img-upload{
                width: 454px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                border-radius: 8px;
                background: #fff;
                border: 1px solid #ddd;
                cursor: pointer;
            }
        }
	}
	footer{
		margin-top: 30px;
		display: flex;
		justify-content: center;
	}
}
</style>
